import { render } from "./MenuControl.vue?vue&type=template&id=752ff84d"
import script from "./MenuControl.vue?vue&type=script&lang=js"
export * from "./MenuControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\registration2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__